import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { formatDate } from '../../common/Utilities';
import Select from 'react-select';
import moment from 'moment';

function ProjectCostingHeader({
  clientName, 
  projectName,
  costingYear,  
  projectCode,
  requestedBy,
  createdAt, 
  platforms,
  costingTotals,
  readOnly, 
  onChangeCostingYear
}) {
  const displayPlatforms = () => {
    let platformCol = [];
    if (platforms.length) {
      let totalMandays = 0;
      let totalManhours = 0;

      let colSize = 0;

      if (platforms.length > 2) {
        colSize = 2;
      }
      else {
        colSize = 3;
      }

      platformCol = platforms.map((platform, key) => {
        costingTotals.length && costingTotals.filter(data => {
          if (data.platformId === platform.id) {
            return data;
          }
          return false;
        }).forEach(total => {
          totalMandays = total.totalMandays.toFixed(2);
          totalManhours = total.totalManhours.toFixed(2);
        })
        return (
          <Col xs={colSize} sm={colSize} md={colSize} lg={colSize} xl={colSize} key={key}>
            <div><b>{platform.platform_name}</b></div>
            <div>{totalMandays}</div> 
            <div>{totalManhours}</div> 
            <div>{platform.chargeability + "%"}</div> 
          </Col>
        )
      })
    }

    return platformCol;
  }

  const displayTotals = () => {
    if (platforms.length) {
      let totalMandays = 0;
      let totalManhours = 0;

      let colSize = 0;

      if (platforms.length >= 2) {
        colSize = 2;
      }
      else {
        colSize = 3;
      }

      platforms.forEach((platform) => {
        costingTotals.length && costingTotals.filter(data => {
          if (data.platformId === platform.id) {
            return data;
          }
          return false;
        }).forEach(total => {
          if (total) {
            totalMandays += parseFloat(total.totalMandays.toFixed(2));
            totalManhours += parseFloat(total.totalManhours.toFixed(2));
          }
        })
      })

      return (
        <Col xs={colSize} sm={colSize} md={colSize} lg={colSize} xl={colSize}>
          <div><b>Total</b></div>
          <div>{totalMandays.toFixed(2)}</div> 
          <div>{totalManhours.toFixed(2)}</div> 
        </Col>
      )
    }
  }

  const displayRequestBy = () => {
    if (!requestedBy || !createdAt) {
      return '';
    }

    createdAt = formatDate(new Date(createdAt));
    return (
      <Row>
        <Col xs={2} sm={2} md={2} lg={2} xl={2}><b>Requested By:</b></Col>
        <Col>{requestedBy}</Col>
        <Col xs={2} sm={2} md={2} lg={2} xl={2}><b>Requested Date:</b></Col>
        <Col>{createdAt}</Col>
      </Row>
    )
  }

  let yearValueIndex = '';
  let years = [];

  for (let y = 0; y < 10; y++) {
    const year = moment().year() - y;
    years.push({
      label: year, 
      value: year
    });
  }

  const selectedYear = costingYear ? costingYear : moment().year();

  years.forEach((year, index) => {
    if (year.value === selectedYear) {
      yearValueIndex = index;
    }
  })

  return (
    <>
      <Row>
        <Col>
          <Row className="mt-3">
            <Col xs={2} sm={2} md={2} lg={2} xl={2}><b>Client: </b></Col>
            <Col>{clientName}</Col>
          </Row>
          <Row>
            <Col xs={2} sm={2} md={2} lg={2} xl={2}><b>Project Name:</b> </Col>
            <Col>{projectName}</Col>
            <Col xs={2} sm={2} md={2} lg={2} xl={2}><b>Project Code:</b> </Col>
            <Col>{projectCode}</Col>
          </Row>
          { displayRequestBy() }
        </Col>
      </Row>
      <Row className="mt-3">
        <Col xs={3} sm={3} md={3} lg={3} xl={3}>
          <Row>
            <Col><b>General Assumptions</b> </Col>
          </Row>
          <Row>
            <Col className="ml-3"><b>Project Mandays</b> </Col>
          </Row>
          <Row>
            <Col className="ml-3"><b>Project Manhours</b></Col>
          </Row>
          <Row>
            <Col className="ml-3"><b>Chargeability</b></Col>
          </Row>
        </Col>
      
        { displayPlatforms() }
        { displayTotals() }
      </Row>
      <Row className="mt-5">
        <Col xs={4} sm={4} md={4} lg={4} xl={4}>
          <Form.Group controlId="costing_year">
            <Form.Label>Costing Year</Form.Label>
            <Select 
              isSearchable={true} 
              isDisabled={readOnly} 
              name="year"  
              id="year" 
              isMulti={false} 
              value={years[yearValueIndex]} 
              options={years} 
              onChange={(value) => {
                onChangeCostingYear(value);
              }} />
          </Form.Group>
        </Col>
      </Row>
    </>
  )
}

export default ProjectCostingHeader